var map = {
	"./1.png": 463,
	"./1215/1.png": 464,
	"./1215/2.png": 465,
	"./1215/3.png": 466,
	"./1215/4.png": 467,
	"./1215/draw_area.png": 468,
	"./1215/draw_rule.png": 469,
	"./1215/win_prize.png": 470,
	"./1314/1.png": 471,
	"./1314/2.png": 472,
	"./1314/3.png": 473,
	"./1314/4.png": 474,
	"./1314/5.png": 475,
	"./1314/draw_area.png": 476,
	"./1314/prize_show.png": 477,
	"./1314/special_win_prize.png": 478,
	"./1314/win_prize.png": 479,
	"./2.png": 480,
	"./3.png": 481,
	"./4.png": 482,
	"./408/1.png": 483,
	"./408/2.png": 484,
	"./408/3.png": 485,
	"./408/4.png": 486,
	"./408/5.png": 487,
	"./408/draw_area.png": 488,
	"./408/prize_show.png": 489,
	"./408/special_win_prize.png": 490,
	"./408/win_prize.png": 491,
	"./715/active_title.png": 492,
	"./715/background.png": 493,
	"./826/1.png": 494,
	"./826/2.png": 495,
	"./826/3.png": 496,
	"./826/4.png": 497,
	"./826/5.png": 498,
	"./826/6.png": 499,
	"./826/7.png": 500,
	"./826/draw_area.png": 501,
	"./826/prize_show.png": 502,
	"./826/special_win_prize.png": 503,
	"./826/win_prize.png": 504,
	"./bean_500.png": 505,
	"./bean_five.png": 506,
	"./bean_one.png": 507,
	"./bean_ten.png": 508,
	"./bean_two.png": 509,
	"./close_store.png": 510,
	"./color_pillar.png": 511,
	"./congratulation.png": 74,
	"./daily/1.png": 512,
	"./daily/1dffblgkl.png": 513,
	"./daily/2.png": 514,
	"./daily/20220107.png": 515,
	"./daily/20220112.png": 516,
	"./daily/20220119.png": 517,
	"./daily/20dffblgkl.png": 518,
	"./daily/2dffblgkl.png": 519,
	"./daily/3.png": 520,
	"./daily/3000_points.png": 521,
	"./daily/30bblgkl.png": 522,
	"./daily/4.png": 523,
	"./daily/40dffblgkl.png": 524,
	"./daily/5000_points.png": 525,
	"./daily/5dffblgkl.png": 526,
	"./daily/80dffblgkl.png": 527,
	"./daily/bqs_ybamy.png": 528,
	"./daily/draw_area.png": 529,
	"./daily/drm_zqtb.png": 530,
	"./daily/gl_jxq.png": 531,
	"./daily/gl_kts.png": 532,
	"./daily/gls_wbl.png": 533,
	"./daily/hdd_wxcdq.png": 534,
	"./daily/he_dcf.png": 535,
	"./daily/hp_dyytj.png": 536,
	"./daily/jy_dgnzzj.png": 537,
	"./daily/mbz_lyej.png": 538,
	"./daily/md_cmy.png": 539,
	"./daily/md_ddg.png": 540,
	"./daily/md_gtj.png": 541,
	"./daily/md_kqzg.png": 542,
	"./daily/md_mbj.png": 543,
	"./daily/md_pbj.png": 544,
	"./daily/md_rsh.png": 545,
	"./daily/ml_czbx.png": 546,
	"./daily/prize_show.png": 547,
	"./daily/rsd_tyj.png": 548,
	"./daily/sbr_dfb.png": 549,
	"./daily/sbr_ylg.png": 550,
	"./daily/special_win_prize.png": 551,
	"./daily/sxjf_ktb.png": 552,
	"./daily/win_prize.png": 553,
	"./daily/xmsh6.png": 554,
	"./daily/xx_jrj.png": 555,
	"./daily/xx_ysh.png": 556,
	"./daily/一等奖.png": 557,
	"./daily/二等奖.png": 558,
	"./daily/抽奖细则.png": 559,
	"./draw_area.png": 560,
	"./draw_btn.png": 561,
	"./draw_rule.png": 562,
	"./draw_wheel.png": 563,
	"./give_up.png": 564,
	"./luck_bg.png": 565,
	"./lucky_title.png": 566,
	"./point_five.png": 567,
	"./point_ten.png": 568,
	"./prize_result.png": 569,
	"./rule_txt.png": 570,
	"./sorry.png": 75,
	"./t.png": 571,
	"./up.png": 572,
	"./wheel_toast_1.png": 573
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 255;


//////////////////
// WEBPACK FOOTER
// ./static/img ^\.\/.*\.png$
// module id = 255
// module chunks = 1